<mat-card>
  <mat-card-header class="availability-header">
    <ui-icon mat-card-avatar faName="info-circle" faStyle="light"></ui-icon>
    <mat-card-title class="availability-title">
      {{ unavailableProductsErrors().length }}
      Artikel im Warenkorb
      @if (unavailableProductsErrors().length > 1) {
        sind
      } @else {
        ist
      }
      nicht verfügbar
    </mat-card-title>
    <mat-card-subtitle class="availability-subtitle">
      @if (unavailableProductsErrors().length > 1) {
        Diese Artikel werden bei der Bestellung nicht berücksichtigt.
      } @else {
        Dieser Artikel wird bei der Bestellung nicht berücksichtigt.
      }
    </mat-card-subtitle>

    @if (showActions()) {
      <ui-button class="availability-header-btn" buttonStyle="text" (click)="toggleShowProductList()">Artikel
        @if (showProductList()) {
          ausblenden
        } @else {
          anzeigen
        }
      </ui-button>
    }
  </mat-card-header>
  @if (showProductList()) {
    <mat-list class="product-list">
      @for (sku of unavailableProductSkusWithoutData(); track sku) {
        <mat-list-item>
          <img matListItemIcon src="./assets/img/package.svg">
          <span matListItemTitle>Paket-Aktion nicht verfügbar</span>
          <span matListItemLine>Art.-Nr.: {{ sku }}</span>
        </mat-list-item>
      }

      @for (unavailableProduct of unavailableProducts(); track unavailableProduct.sku) {
        <mat-list-item>
          <img matListItemIcon [alt]="unavailableProduct.images[0].small" [src]="unavailableProduct.images[0].small">
          <span matListItemTitle>{{ unavailableProduct.name }}</span>
          <span matListItemLine>Art.-Nr.: {{ unavailableProduct.ean?.article }}</span>
        </mat-list-item>
      }
    </mat-list>

    @if (showActions()) {
      <mat-card-actions class="actions">
        <ui-button
          class="delete-button"
          buttonStyle="outlined"
          [loading]="loading()"
          [disabled]="loading()"
          (click)="deleteUnavailableProducts.emit(unavailableProductsSkus())">
          {{ unavailableProductsErrors().length }} Artikel löschen
        </ui-button>
      </mat-card-actions>
    }
  }
</mat-card>
